import { selectCubeLinesContextForTab, selectTabById, useAppSelector } from '@core/core/store'
import type { ActiveEntity } from '@core/core/types'
import type { TabId } from 'common/types'
import { BaseObjectArray } from 'common/types'

export const useTabsContext = (tabId: TabId) => {
  const tab = useAppSelector(state => selectTabById(state, tabId))
  const cubeLinesContextForTab = useAppSelector(state =>
    selectCubeLinesContextForTab(state, tabId, tab),
  )

  const tabContext = tab?.context ?? []
  const tabHalfContext = tab?.halfContext ?? []

  const activeEntities: ActiveEntity[] = [
    ...tabContext,
    ...tabHalfContext,
    ...cubeLinesContextForTab,
  ].reduce<ActiveEntity[]>((arr, entity) => {
    if (
      entity.entityId != null &&
      entity.entityType !== 'unknown' &&
      BaseObjectArray.includes(entity.entityType)
    ) {
      arr.push({
        entityType: entity.entityType,
        entityId: entity.entityId,
        entityName: entity.entityName,
        customProperties: entity.customProperties,
      })
    }
    return arr
  }, [])

  return activeEntities
}
